import { DELETE_GENRE, GET_ARTISTS, GET_CHARTS, GET_COUNTRIES, GET_GENRES, GET_TAGS, POST_GENRE, PUT_GENRE, SET_FILTER, SET_FILTERS_I18N } from './actions';

const initialState = {
  /**
   * The number of pages loaded for the
   * current filter selection
   */
  pagination: {
    page: 0,
    total: 0,
  },

  /**
   * Featured genres for the top header
   */
  featured: [],

  /**
   * Filters to explore popular songs
   */
  filters: {
    artists: {
      selections: [],
      list: [],
    },
    tags: {
      selections: [],
      list: [],
    },
    genres: {
      selections: [],
      list: [],
    },
    when: {
      selections: [],
      list: [],
    },
    countries: {
      list: [],
      selections: [],
    },
    genders: {
      selections: [],
      list: [
        { id: 'Male', name: 'Male' },
        { id: 'Female', name: 'Female' },
        { id: 'Other', name: 'Other' },
      ],
    },
    vocals: {
      selections: [],
    },
    bpm: {
      selections: [],
    },
    instruments: {
      selections: [],
    },
    moods: {
      selections: [],
    },
  },

  /**
   * The list of songs for the given filters
   */
  songs: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case DELETE_GENRE.SUCCESS:
      return {
        ...state,
        filters: {
          ...state.filters,
          genres: {
            ...state.filters.genres,
            list: state.filters.genres.list.filter((gnr) => gnr.id !== action.data.genre.id),
          },
        },
      };
    case GET_ARTISTS.SUCCESS:
      return {
        ...state,
        filters: {
          ...state.filters,
          artists: {
            ...state.filters.artists,
            list: action.payload.artists,
          },
        },
      };
    case GET_COUNTRIES.SUCCESS:
      return {
        ...state,
        filters: {
          ...state.filters,
          countries: {
            ...state.filters.countries,
            list: action.payload.countries,
          },
        },
      };
    case GET_CHARTS.SUCCESS:
      return {
        ...state,
        total: action.payload.meta.total,
        songs: action.payload.songs,
      };
    case GET_GENRES.SUCCESS:
      return {
        ...state,
        featured: action.payload.genres.filter(genre => genre.featured),
        filters: {
          ...state.filters,
          genres: {
            ...state.filters.genres,
            list: action.payload.genres,
          },
        },
      };
    case GET_TAGS.SUCCESS:
      return {
        ...state,
        filters: {
          ...state.filters,
          tags: {
            ...state.filters.tags,
            list: action.payload.tags,
          },
        },
      };
    case POST_GENRE.SUCCESS:
      return {
        ...state,
        filters: {
          ...state.filters,
          genres: {
            ...state.filters.genres,
            list: [...state.filters.genres.list, action.payload.genre],
          },
        },
      };
    case PUT_GENRE.SUCCESS:
      return {
        ...state,
        filters: {
          ...state.filters,
          genres: {
            ...state.filters.genres,
            list: state.filters.genres.list.map((gnr) => {
              if (gnr.id === action.payload.genre.id) {
                return action.payload.genre;
              }
              return gnr;
            }),
          },
        },
      };
    case SET_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.payload.filter]: {
            ...state.filters[action.payload.filter],
            selections: action.payload.value,
          },
        },
      };
    case SET_FILTERS_I18N:
      return {
        ...state,
        filters: {
          ...state.filters,
          when: {
            ...state.filters.when,
            list: action.payload.when.list,
          },
        },
      };
    default:
      return state;
  }
}
